import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function EmailVerified() {
  const [params] = useSearchParams();
  const success = params.get('success') === 'true';
  const message = params.get('message') || '';
  const code = params.get('code') || '';
  const navigate = useNavigate();

  useEffect(() => {
    if (success) {
      const t = setTimeout(() => navigate('/', { replace: true }), 3000);
      return () => clearTimeout(t);
    }
  }, [success, navigate]);

  return (
    <section style={{ maxWidth: 560, margin: '56px auto', padding: '0 20px' }}>
      <h1>{success ? 'Email verified!' : 'Verification status'}</h1>
      {message && <p>{decodeURIComponent(message)}</p>}
      {!success && code && <p>Code: {code}</p>}
      <button onClick={() => navigate('/')} className="btn btn-primary">Go Home</button>
    </section>
  );
}